import {call, put} from 'redux-saga/effects';
import ReportsActions from '../redux/ReportsRedux';
import MessagesActions from '../redux/MessagesRedux';

export function * getReports(api, action) {
  const response = yield call(api.getReports, {...action.props});

  if (response.ok) {
    yield put(ReportsActions.reportsSuccess({...response.data, ...action.props}));
  } else {
    yield put(ReportsActions.reportsFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}
